import React from 'react';
import { Frame, Stack } from 'framer';
import styled from 'styled-components';

const BarStyle = {
    width: '5rem',
    height: '30rem',
    backgroundColor: 'var(--secondary-color)',
    borderRadius: '5rem',
    margin: '3rem',
    // boxShadow: '-1px 1px 10px #000',
}

const transition = {
    flip: Infinity,
    ease: "ease-in",
    duration: 3,
}

const Container = styled.div`
    display: inline-flex;
    flex-direction: row;
    // border: 1px solid white;
`

const Logo = props => {
    return(
        <Container>
            <Frame 
                position="relative"
                style={BarStyle} 
                animate={{ backgroundColor: '#999999', boxShadow: '-7px 7px 7px #000'}}
                transition={transition}
                />
            <Frame 
                position="relative"
                style={BarStyle} 
                animate={{ backgroundColor: '#999999', boxShadow: '-7px 7px 7px #000'}}
                transition={transition}
            />
        </Container>
    )
}

export default Logo;